<template>
  <div class="print_box">
    <div
      class="print_main"
      v-for="pageItem in totalCount"
      :key="'pageItem' + pageItem"
    >
      <div
        class="user_parint_title"
        v-html="removeHtmlTags(meetingInfo.MeetingName)"
      ></div>
      <div class="user_parint_desc">
        1.请您用微信扫描下方二维码，填入用户名及密码进行登录（随机无记名方式）。
      </div>
      <div class="user_parint_desc">
        2.对每一个测评象的素质、能力、业绩，<strong
          >每项分别打分1-100分。</strong
        >
      </div>
      <div class="user_parint_desc">
        3.完成所有测评打分后点击“提交”，即完成测评。
        类别：公司领导/中层干部/职工代表
      </div>
      <div class="user_parint_bar">
        <span> 类别：</span>
        <span
          v-html="
            userList[(pageItem - 1) * pageSize + 0].UserName.replace(/\d/g, '')
          "
        ></span>
      </div>
      <div class="user_parint_name" v-show="showName === '1'">
        {{ userList[(pageItem - 1) * pageSize + 0].UserName }}
      </div>
      <table class="user_print_table">
        <tr>
          <td rowspan="2" class="user_print_table_td1">
            <el-image
              class="user_print_table_image"
              :src="meetingInfo.MeetingWXCodeUrl"
            >
            </el-image>
            <div>{{ printTip }}</div>
          </td>
          <td class="user_print_table_td2" style="width: 140px">用户名：</td>
          <td class="user_print_table_td2" style="width: 235px">
            {{ userList[(pageItem - 1) * pageSize + 0].Phone }}
          </td>
        </tr>
        <tr>
          <td class="user_print_table_td3" style="width: 140px">密 码：</td>
          <td class="user_print_table_td3" style="width: 235px">
            {{ userList[(pageItem - 1) * pageSize + 0].Password }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import voteUserApi from '../../../api/vote/voteUser'
export default {
  name: 'Home',
  components: {

  },
  data () {
    return {
      meetingInfo: {
        MeetingWXCodeUrl: '',
        MeetingCodeUrl: ''
      },
      listQuery: {
        meetingGroupID: null,
        maxResultCount: 99999,
        skipCount: 0
      },
      userList: [],
      userGroup: {},
      userVoteNumber: null,
      printTip: '',
      showName: '1',
      totalCount: 0,
      pageSize: 1
    }
  },
  methods: {
    getMeetingVoteInfo: function () {
      const _this = this
      _this.openLoading()
      _this.$api.meetingManage.getMeetingVoteInfo({
        meetingID: _this.$route.params.mid
      }).then(data => {
        this.meetingInfo = data
        this.getVoteUsers()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    getVoteUsers: function () {
      const _this = this
      _this.openLoading()
      voteUserApi.getVoteUsers(_this.listQuery).then(data => {
        data.Items.forEach(item => {
          if (item.UserVoteNumber === _this.userVoteNumber) {
            _this.userList.push(item)
          }
        })
        if (_this.userList.length % _this.pageSize === 0) {
          _this.totalCount = parseInt(_this.userList.length / _this.pageSize)
        } else {
          _this.totalCount = parseInt(_this.userList.length / _this.pageSize) + 1
        }
        // _this.totalCount = _this.userList.length / 3
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    removeHtmlTags: function (str) {
      return str.replace(/<[^>]*>/g, '')
    }
    // getVoteUserGroup: function () {
    //   const _this = this
    //   _this.openLoading()
    //   voteUserApi.getVoteUserGroup({
    //     meetingUserGroupID: _this.$route.params.gid
    //   }).then(data => {
    //     this.userGroup = data
    //     console.log(this.userGroup)
    //     this.getVoteUsers()
    //   }).catch(err => {
    //     _this.openLoading().close()
    //     return err
    //   })
    // }
  },
  computed: {

  },
  created () {
    this.printTip = this.$route.params.tip
    this.showName = this.$route.params.sn
    this.userVoteNumber = Number(this.$route.params.vn)
    this.listQuery.meetingGroupID = this.$route.params.gid
    this.getMeetingVoteInfo()
  }
}
</script>
<style lang="less">
html {
  overflow-y: visible;
}
body {
  overflow-y: visible;
}
.print_box {
  height: 100%;
  width: 100%;
}
.print_main {
  width: 640px;
  height: 936px;
  padding: 70px 0px 40px 0px;
  margin: 0px auto;
}
.user_print_table {
  border: 1px solid black;
  width: 100%;
  border-spacing: 0px;
  margin: 0px 0px 60px 0px;
  background-color: #fff;
}
.user_print_table tr {
  padding: 0px;
}
.user_print_table tr td {
  padding: 0px;
}
.user_print_table_td1 {
  width: 260px;
  padding: 0px;
  text-align: center;
}
.user_print_table_td2 {
  border-width: 0px 0px 1px 1px;
  border-color: black;
  border-style: solid;
  text-align: center;
  font-weight: 600;
  font-size: 20px;
}
.user_print_table_td3 {
  border-width: 0px 0px 0px 1px;
  border-color: black;
  border-style: solid;
  text-align: center;
  font-weight: 600;
  font-size: 20px;
}
.user_print_table_image {
  margin: 10px 0px;
  width: 185px;
}
.user_parint_name {
  width: 100%;
  height: 20px;
  text-align: right;
  line-height: 20px;
  font-weight: 700;
}
.user_parint_title {
  width: 100%;
  margin: 0px 0px 45px 0px;
  font-size: 26px;
  font-weight: 600;
  text-align: center;
}
.user_parint_desc {
  width: 100%;
  margin: 15px 0px;
  font-size: 18px;
}
.user_parint_bar {
  width: 100%;
  margin: 150px 0px 10px 0px;
  font-size: 18px;
}
</style>
